// React&NextJS
import React from 'react'
// Styles
import s from './EmailPreferences.module.scss'
import classnames from 'classnames'
// Components
import { Input } from '../../core/input/Input'
import { Text } from '../../core/text/Text'

const c = classnames.bind(s)

type Props = {
    setSettings: Function
    settings: {
        condAnnouncements: boolean
        obitAnnouncements: boolean
        mailAnnouncements: boolean
    }
    terms?: boolean
    setTerms?: Function
    newAuth?: boolean
    className?: string
}

function EmailPreferences({
    settings,
    setSettings,
    terms,
    setTerms,
    newAuth,
    className,
}: Props) {
    const updateMailSetting = () => {
        const newSettings = settings
        newSettings.mailAnnouncements = !newSettings.mailAnnouncements

        // Update state
        setSettings({ ...newSettings })
    }

    return (
        <div className={c(s.checkBoxes, className && s[className])}>
            <div className={s.options}>
                {newAuth && (
                    <>
                        <Text variant="p-small" className={s.warning}>
                            Til að stofna minningarsíður eða setja efni inn á
                            vefinn Minningar.is þarf að samþykkja{' '}
                            <a
                                href="https://minningar.is/terms-of-use"
                                target="_blank"
                                rel="noreferrer"
                            >
                                notendaskilmála vefsins Minningar.is
                            </a>
                        </Text>
                        <Input
                            type="checkbox"
                            label="Ég samþykki notendaskilmála vefsins Minningar.is"
                            onChange={() => setTerms((prev: boolean) => !prev)}
                            checked={terms}
                        />
                    </>
                )}
                <Input
                    type="checkbox"
                    id="mailAnnouncements"
                    name="mailAnnouncements"
                    label="Ég vil fá póst frá Minningar.is"
                    onChange={updateMailSetting}
                    checked={settings.mailAnnouncements}
                />
            </div>
        </div>
    )
}

export default EmailPreferences
